var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_7_564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2428 11.7427L9 15.9855L4.75725 11.7427C3.91817 10.9036 3.34675 9.83452 3.11527 8.67064C2.88378 7.50676 3.00262 6.30038 3.45676 5.20404C3.91089 4.1077 4.67993 3.17065 5.66661 2.51137C6.6533 1.8521 7.81333 1.50021 9 1.50021C10.1867 1.50021 11.3467 1.8521 12.3334 2.51137C13.3201 3.17065 14.0891 4.1077 14.5433 5.20404C14.9974 6.30038 15.1162 7.50676 14.8847 8.67064C14.6533 9.83452 14.0818 10.9036 13.2428 11.7427ZM3.75 16.5H14.25V18H3.75V16.5Z",
    fill: "#2B32B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationContact);
export default __webpack_public_path__ + "static/media/location_contact.5f96c16c353bfb7c990e03677dfec0e2.svg";
export { ForwardRef as ReactComponent };